import moveViewBoxAction from './original/moveViewBox';
import selectHall from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/selectHall';
import save from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/actions/storage/save';

function moveViewBox(payload) {
    return (dispatch, getState) => {
        dispatch(moveViewBoxAction(payload));
        const { entityId } = selectHall(getState());
        dispatch(save(entityId));
    };
}

export default moveViewBox;
